import { gql } from '@apollo/client';

export interface UserEmployer {
  primary: Boolean;
  employeeId: string;
  employerId: string;
  employer: Employer;
  verifiedOn?: string;
}

export interface Employer {
  id: string;
  name: string;
  shortName: string;
  createdAt?: string;
  subdomain?: string;
}

export interface GetUserEmployersResponse {
  userEmployers: UserEmployer[];
}

export const GET_USER_EMPLOYERS = gql`
  query GET_USER_EMPLOYERS($uuid: ID!) {
    userEmployers: employmentService_getAllEmployeesForUserId(userId: $uuid, includeDeleted: true) {
      primary
      employeeId
      employerId
      employer {
        name
        shortName
        createdAt
      }
      verifiedOn
    }
  }
`;

export const GET_EMPLOYER = gql`
  query GET_EMPLOYER($id: ID!) {
    employmentService_getEmployer(id: $id) {
      id
      name
      shortName
      subdomain
    }
  }
`;
